import AboutPage from './AboutPage';
export * from './AboutPage';
export default AboutPage;
